import React from 'react';
import { motion } from 'framer-motion';

export const EASE = [0.16, 1, 0.3, 1];
export const pageVariants = { initial: { opacity: 0, y: 18 }, animate: { opacity: 1, y: 0, transition: { duration: 0.45, ease: EASE } }, exit: { opacity: 0, y: -14, transition: { duration: 0.25, ease: EASE } } };
export const stagger = { animate: { transition: { staggerChildren: 0.07, delayChildren: 0.05 } } };
export const rise = { initial: { opacity: 0, y: 16 }, animate: { opacity: 1, y: 0, transition: { duration: 0.5, ease: EASE } } };
export const pop = { initial: { opacity: 0, scale: 0.92 }, animate: { opacity: 1, scale: 1, transition: { type: 'spring', stiffness: 320, damping: 24 } } };

export const Page = ({ children, className = '', testId }) => (
  <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit" className={className} data-testid={testId}>{children}</motion.div>
);

export const MotionButton = ({ children, className = '', variant = 'primary', ...props }) => (
  <motion.button whileHover={{ scale: props.disabled ? 1 : 1.02 }} whileTap={{ scale: props.disabled ? 1 : 0.96 }} transition={{ type: 'spring', stiffness: 420, damping: 24 }} className={`st-btn st-btn-${variant} ${className}`} {...props}>
    {children}
  </motion.button>
);

export const Card = ({ children, className = '', strong = false, ...props }) => (
  <motion.div variants={rise} className={`${strong ? 'st-glass-strong' : 'st-glass'} rounded-[1.75rem] ${className}`} {...props}>{children}</motion.div>
);
